import React from 'react'
import styles from './styles.module.css'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { useHotmartEvent } from '../../hooks/useHotmartEvent'

const Alert = ({ children, link = '', linklabel = '', buttonicon = '', title = '', type = 'info', eventdh = '' }) => {
  const { sendHotmartEvent } = useHotmartEvent()

  const iconMap = {
    credential: 'user-shield',
    error: 'siren-on',
    info: 'info-circle',
    success: 'star',
    warning: 'exclamation-triangle',
  }

  const sendDHEvent = event => {
    if(!eventdh) {
      return void 0
    }

    const evtData = {name:eventdh, url: event.currentTarget.href}

    sendHotmartEvent({ 
      entity: 'tracking',
      action: 'download',
      event: evtData,
    })
  }

  const linkMap = {
    urlWebhook: process.env.URL_WEBHOOK,
  }

  return (
    <span className={`${styles.alert} ${styles[type]}`}>
      {title && (
        <span className={styles.title} data-testid="alert-title">
          {iconMap[type] && <FontAwesomeIcon data-testid="alert-icon" icon={['far', iconMap[type]]} />}
          {title}
        </span>
      )}
      <span className={`${styles.content}`}>{children}</span>
      {link && linklabel && (
        <a className={styles.link} onClick={(event) => sendDHEvent(event)} data-testid="alert-link" href={linkMap[link] || link} target="_blank" rel="noopener noreferrer">
          {linklabel}

          {buttonicon && <FontAwesomeIcon icon={['fal', buttonicon]} />}
        </a>
      )}
    </span>
  )
}

export default Alert
